import React, {PropTypes} from 'react';

const {default: Input} = require('module-tsl-ui-components/es5/components/input/Input');

const CustomInput = ({input, id, keyword, type = 'text', placeholder, autoFocus = false, classNames, ...otherProps}) => {
  const inputProps = Object.assign({}, input, {id, value: keyword, type, autoFocus, placeholder, classNames});
  return (
    <Input {...inputProps} onChange={(e) => { input.onChange(e); }} {...otherProps} />
  );
};

CustomInput.propTypes = {
  input: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
  type: PropTypes.string,
  classNames: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  onChangeHandler: PropTypes.func,
};

export default CustomInput;
